
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("crGHY"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("crGHY", function(module, exports) {

let $90f9229ea60735fd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $90f9229ea60735fd$var$load("h3ABO"),
    $90f9229ea60735fd$var$load("jIVfy"),
    $90f9229ea60735fd$var$load("aNhGE"),
    $90f9229ea60735fd$var$load("djHM5"),
    $90f9229ea60735fd$var$load("eJQji"),
    $90f9229ea60735fd$var$load("2YffH"),
    $90f9229ea60735fd$var$load("aGWeM"),
    $90f9229ea60735fd$var$load("6mHrv"),
    $90f9229ea60735fd$var$load("awWN9"),
    $90f9229ea60735fd$var$load("9CYct"),
    $90f9229ea60735fd$var$load("gQllS"),
    $90f9229ea60735fd$var$load("bxrdv"),
    $90f9229ea60735fd$var$load("hZtKG"),
    $90f9229ea60735fd$var$load("iNmaF"),
    $90f9229ea60735fd$var$load("lVO3w"),
    $90f9229ea60735fd$var$load("hyzoX"),
    $90f9229ea60735fd$var$load("h9Ed7"),
    $90f9229ea60735fd$var$load("eBRUf"),
    $90f9229ea60735fd$var$load("kbRvk"),
    $90f9229ea60735fd$var$load("k8QRJ"),
    $90f9229ea60735fd$var$load("43bfx"),
    $90f9229ea60735fd$var$load("cD6Zr"),
    $90f9229ea60735fd$var$load("9wzNh"),
    $90f9229ea60735fd$var$load("8YSo7"),
    $90f9229ea60735fd$var$load("3Zfzp"),
    $90f9229ea60735fd$var$load("9ldRJ"),
    $90f9229ea60735fd$var$load("50ame"),
    $90f9229ea60735fd$var$load("e7ZUf"),
    $90f9229ea60735fd$var$load("gL8bn"),
    $90f9229ea60735fd$var$load("ebWFc"),
    $90f9229ea60735fd$var$load("6iz6l"),
    $90f9229ea60735fd$var$load("4SCW2"),
    $90f9229ea60735fd$var$load("855o0"),
    $90f9229ea60735fd$var$load("8MfZE"),
    $90f9229ea60735fd$var$load("hv4mn"),
    $90f9229ea60735fd$var$load("Wowvf"),
    $90f9229ea60735fd$var$load("dek7I"),
    $90f9229ea60735fd$var$load("3SmkN"),
    $90f9229ea60735fd$var$load("dYtBN"),
    $90f9229ea60735fd$var$load("kNV5Y"),
    $90f9229ea60735fd$var$load("6wr18"),
    $90f9229ea60735fd$var$load("kjZZD"),
    $90f9229ea60735fd$var$load("2zxmz"),
    $90f9229ea60735fd$var$load("7269o"),
    $90f9229ea60735fd$var$load("3JSgG"),
    $90f9229ea60735fd$var$load("37ldp"),
    $90f9229ea60735fd$var$load("ffEVr"),
    $90f9229ea60735fd$var$load("dRpV3"),
    $90f9229ea60735fd$var$load("dTsOE"),
    $90f9229ea60735fd$var$load("hhss7"),
    $90f9229ea60735fd$var$load("jYUNl"),
    $90f9229ea60735fd$var$load("foy8I"),
    $90f9229ea60735fd$var$load("jY21r"),
    $90f9229ea60735fd$var$load("dP7ao"),
    $90f9229ea60735fd$var$load("hogcU"),
    $90f9229ea60735fd$var$load("i8eeg"),
    $90f9229ea60735fd$var$load("iFdoJ"),
    $90f9229ea60735fd$var$load("7EorR"),
    $90f9229ea60735fd$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.9632b922.js.map
